import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"cancel\"><path d=\"M499 106c16-16 16-45 0-61l-35-35c-16-16-45-16-61 0L285 131c-16 16-45 16-61 0L106 13C90-3 64-3 45 13L13 45c-16 16-16 45 0 61l118 118c16 16 16 45 0 61L13 403c-16 16-16 45 0 61l35 35c16 16 45 16 61 0l118-118c16-16 45-16 61 0l118 118c16 16 45 16 61 0l35-35c16-16 16-45 0-61L384 285c-16-16-16-45 0-61z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cancel.svg
// module id = 180
// module chunks = 0